export default "__VITE_ASSET__D0w6JVLr__"